import {observable, action, runInAction, computed} from 'mobx'
import {message} from 'antd'
import {json, get} from '../../../../utils/ajax'
import {handleSeerchAndPage, objToValueObj,} from "../../../../utils/Utils"

class FaultCaseContentMaintenanceStore {

    @observable loading
    @observable pagination //分页
    @observable contentList //故障案例内容列表数据
    @observable addVisible //控制新增模态框显示
    @observable addTitle //控制新增模态框标题
    @observable addFields //控制新增模态框显示字段回显
    @observable editArgId //点击修改时保存id
    @observable upLoading //上传转动loading
    @observable carseriesList //获取车系列表下拉数据
    @observable systemList  //获取系统下拉列表
    @observable symptomList //获取现象下拉列表
    @observable faultList //获取故障下拉列表
    @observable faultCodeList  //获取故障码下拉列表
    @observable standardList //获取标准下拉列表
    @observable importReturnData //导入返回值
    @observable showDrawer //导入抽屉
    @observable numberOnly //判断编号是否存在  true存在，否为不存在

    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.contentList = []
        this.addVisible = false
        this.addTitle=''
        this.editArgId=''
        this.addFields = {}
        this.upLoading=false
        this.carseriesList = []
        this.systemList = []
        this.symptomList = []
        this.faultList = []
        this.faultCodeList = []
        this.standardList = []
        this.importReturnData = []
        this.showDrawer = false
        this.numberOnly=false
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**初始化页面**/
    @action
    initListPage = async (page,value) => {
        this.loading = true
        let values = {
            number:value
        }
        let searchFields = value ? values : {}
        let searchResult = handleSeerchAndPage(page, this.pagination,searchFields) //多条件分页的轮子
        searchResult.size = this.pagination.pageSize
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/foregroundQueryPageList`,searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.contentList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements ? res.totalElements : 0} 条`
            }
            this.loading = false
        })
    }

    //删除
    @action
    deleteList= async (id)=>{
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/delById/id/${id}`)
        runInAction(()=>{
            if(res.status){
                message.success(res.data)
                this.initListPage(this.pagination.current)
            }
        })

    }


    /** 开启抽屉 **/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /** 关闭抽屉 **/
    @action
    onClose = () => {
        this.showDrawer = false
    }



    //获取修改表单值
    @action
    getUpdateList=async(id)=>{
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/selectById/${id}`)
        runInAction(()=>{
            this.editArgId=id
            this.addVisible=true
            this.addTitle='修改'
            let ress={
                ...res,
                carseries:res.carseries !=='无' ? res.carseries :'',
                failure:res.failure !=='无' ? res.failure.split(',') :[],
                system:res.system !=='无' ? res.system.split(',') :[],
                faultCode:res.faultCode !=='无' ? res.faultCode.split(',') :[],
                phenomenon:res.phenomenon !=='无' ? res.phenomenon.split(',') :[],
                standard:res.standard !=='无' ? res.standard.split(',') :[],
            }
            this.addFields={...objToValueObj(ress), systemDiagramUrl:res.systemDiagramUrl}
        })
    }

    /** 新增开启模态框 **/
    @action
    showAddBox = (record, option) => {
        runInAction(() => {
            this.addFields = {}
            this.addTitle='新增'
            this.addVisible = true
        })
    }

    @computed
    get fields() {
        let fields = {
            code: {value: this.addFields.code},
            name: {value: this.addFields.name},
        }
        return fields
    }

    //Cast
    @action
    onEditFieldChange(changedFields) {
        this.addFields = {...this.addFields, ...changedFields}
    }


    // //获取车系下拉列表
    // @action
    // getCarseries = async () => {
    //     const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/carFramePullDownList`)
    //     runInAction(() => {
    //         this.carseriesList = Array.isArray(res) ? res : []
    //     })
    // }

    //获取标准下拉列表
    @action
    getStandard = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/standardDropDownBoxList`)
        runInAction(() => {
            this.standardList = Array.isArray(res) ? res : []
        })
    }

    //获取故障码下拉列表
    @action
    getFaultCode = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseErrorCode/theFaultCodeDropDownListBoxList`)
        runInAction(() => {
            this.faultCodeList = Array.isArray(res) ? res : []
        })
    }

    //获取故障下拉列表
    @action
    getFault = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/faultDropDownBoxList`)
        runInAction(() => {
            this.faultList = Array.isArray(res) ? res : []
        })
    }

    //获取现象下拉列表
    @action
    getSymptom = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/symptomDropDownBoxList`)
        runInAction(() => {
            this.symptomList = Array.isArray(res) ? res : []
        })
    }

    //获取系统下拉列表
    @action
    getSystem = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseSystem/systemDownBoxList`)
        runInAction(() => {
            this.systemList = Array.isArray(res) ? res : []
        })
    }

    //保存新增基础数据
    @action
    saveAddField=async (values)=>{
        let args ={...values,
            failure:values.failure ? values.failure.toString() :'',
            system:values.system ? values.system.toString() :'',
            faultCode:values.faultCode ? values.faultCode.toString() :'',
            phenomenon:values.phenomenon ? values.phenomenon.toString() :'',
            standard:values.standard ? values.standard.toString() :'',
            systemDiagramUrl:this.addFields.systemDiagramUrl ? this.addFields.systemDiagramUrl :'',
        }
        if(this.addTitle==='新增'){
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/addContentTitle`,args)
            runInAction(()=>{
                if(res.status){
                    message.success(res.data)
                    this.addVisible=false
                    this.initListPage()
                }
            })
        }else if(this.addTitle==='修改'){
            let editArg={...args,id:this.editArgId}
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/update`,editArg)
            runInAction(()=>{
                if(res.status){
                    message.success(res.data)
                    this.addVisible=false
                    this.initListPage(this.pagination.current)
                }
            })
        }

    }

    //以编号作为唯一判断，判断是否存在
    @action
    getNumberExist=async (value) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentTitle/faultCodeList`)
        if(res){
            runInAction(() => {
                this.numberOnly = res && res.includes(value)
            })
        }
    }


    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
      if (info.file.status === 'uploading') {
          runInAction(() => {
              this.upLoading = true
          })
          return
        }
      if (info.file.status === 'done') {
          runInAction(() => {
              this.addFields ={...this.addFields, systemDiagramUrl:info.file.response}
              this.upLoading = false
          })
          return
        }
      if (info.file.status === 'error') {
            runInAction(() => {
                this.upLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }


}

export default new FaultCaseContentMaintenanceStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/FaultDiagnosis/FaultCaseContentMaintenance/store.js